import React from 'react';
import { BRAND, isMarketGB } from '../constants/main';

export const DynamicYield = () => {
    return (
        <script
            type="text/javascript"
            dangerouslySetInnerHTML={{
                __html: `    var gdprCountryRegex = /fr|de|be|uk|gb|ch|es|it|at|lu|nl|pt|pl|bg|hr|dk|ee|fi|gr|hu|ie|lt|lt|mt|ro|sk|si|se|cz|no|gp|mq|gf|yt|re|tr|br/;
                window.DY = window.DY || {};
                window.DYO = window.DYO || {};
                var dataLayer = window['dataLayer']||[];
                
            
                 setTimeout(function() {
                        getDataLayerLoadedInterval = setInterval(getDataLayerLoaded, 100);
                    }, 10);
                
                    setTimeout(function() {
                        clearInterval(getDataLayerLoadedInterval);
                    }, 60000);
                    
                function searchLastEventDataLayer(eventName) {
                    var lastIndex = -1;
                    dataLayer.map(function (key, index) {
                        if (key.brand === eventName) {
                            if (index > lastIndex) {
                                lastIndex = index;
                            }
                        }
                    });
                    return lastIndex;
                }
                 
            function getDataLayerLoaded(){
                
                var eventSearchIndex = searchLastEventDataLayer("${{ AP: 'peugeot', AC: 'citroen', DS: 'ds', OV: isMarketGB ? 'vauxhall' : 'opel' }[BRAND]}");
                var currentMainStepName = -1;
            
                if (eventSearchIndex > -1) {
                        currentMainStepName = dataLayer[eventSearchIndex]["country"];
                        DYConsentManager(currentMainStepName);
                        clearInterval(getDataLayerLoadedInterval);
                    }	
            }
            
                function activeConsent(value){
                    if(window.DY) {
                        window.DY.userActiveConsent = {accepted: value};
                    } 
                    if(window.DYO && window.DYO.ActiveConsent){
                        window.DYO.ActiveConsent.updateConsentAcceptedStatus(value);
                    }
                    console.log("[ANA]DYConsentIsgiven: " + value);
                }
                
                function DYConsentManager(countryIsGDPR){
                // --- If the country is included in the gdpr zone  --- //
                 if (gdprCountryRegex.test(countryIsGDPR)) {
                     // --- If it is an old user --- //
                     var dCookie = document.cookie;
                     if (dCookie.includes("_psac_gdpr_consent_given")) {
                         if (dCookie.includes("_psac_gdpr_consent_purposes=[cat_ana]")) {
                             activeConsent(true);
                         } else {
                             activeConsent(false);
                         }
                     }else{
                         setTimeout(function () {
                             try {
                                 var datalayerInterval = setInterval(function () {
                                     var datalayerIteratif = window.dataLayer;
                                     for (const item in datalayerIteratif) {
                                         if (
                                             datalayerIteratif[item]["event"] ===
                                             "gdprclosepopin"
                                             ) {
                                             var dCookie = document.cookie;
                                         if (dCookie.includes("_psac_gdpr_consent_given")) { 
                                             if (dCookie.includes("_psac_gdpr_consent_purposes=[cat_ana]")) {
                                                 window.DY.userActiveConsent = {accepted : true};
                                                 window.DYO.ActiveConsent.updateConsentAcceptedStatus(true);
                                                 console.log("DYConsentIsgiven: true");
                                             } else {
                                                window.DY.userActiveConsent = { accepted: false }
                                                window.DYO.ActiveConsent.updateConsentAcceptedStatus(false);
                                                console.log("DYConsentIsgiven: false");
                                             }
                                         }else {
                                             console.log("DYConsent: Waiting ...");
                                         }
                                         clearInterval(datalayerInterval);
                                     }
                                 }
                             }, 500)
                             } catch (error) {
                                 console.log('DYConsent: Waiting datalayer ...')
                             }
                         }, 10);
                     }
            
                 }else{
                     window.DY.userActiveConsent = { accepted: true };
                 }
                }
            `,
            }}
        />
    );
};
